import { forwardRef } from "react";
import * as SheetPrimitive from "@radix-ui/react-dialog";
import { useTranslations } from "next-intl";

import {
  SHEET_CLOSE_CLASS,
  SHEET_CLOSE_ICON,
  type TSheetCloseElement,
  type TSheetCloseProps,
} from "@/ui/components/overlay/Sheet/Sheet.config";
import { cn } from "@/ui/lib";
import { Icon } from "../../primitives";

export const SheetClose = forwardRef<TSheetCloseElement, TSheetCloseProps>(
  ({ "aria-label": ariaLabel, className, ...props }, ref) => {
    const t = useTranslations("Libs.UI.Components.Sheet.SheetClose");

    return (
      <SheetPrimitive.Close
        aria-label={ariaLabel ?? t("close")}
        data-component="SheetClose"
        ref={ref}
        {...props}
        className={cn(SHEET_CLOSE_CLASS, className)}
      >
        <Icon icon={SHEET_CLOSE_ICON} />
      </SheetPrimitive.Close>
    );
  },
);

SheetClose.displayName = SheetPrimitive.Close.displayName;
